import { menus } from '.';

export function validaAcessoMenu(user) {
  const flatMenu = menus()
    .flatMap(menu => {
      if (menu.menus) {
        return menu.menus.map(subMenu => ({
          ...subMenu,
          parent_id: menu.id,
          permissoes_que_habilitam_menu: [
            ...menu.permissoes_que_habilitam_menu,
            ...subMenu.permissoes_que_habilitam_menu,
          ].filter((item, index, self) => self.indexOf(item) === index),
        }));
      }
      return [menu];
    })
    .map(menu => ({
      permissoes: menu.permissoes_que_habilitam_menu,
      url: menu.url,
    }));

  const url = user.permissions
    .map(permission =>
      flatMenu
        .filter(menu => menu.permissoes.includes(permission))
        .map(menu => menu.url)
    )
    .filter(menu => menu.length > 0)
    .flatMap(menu => menu)[0];

  return url;
}
